// Swaps ASCII `"` and `'` for the proper Hebrew gershayim (U+05F4) and geresh
// (U+05F3). Pure-Hebrew display fonts almost never include glyphs for the
// ASCII characters, so the browser falls back to a system font for just those
// chars — which is why quotes in a Hebrew template render in a different
// typeface than the surrounding letters. Use only for RTL fields.
export function swapHebrewQuotes(text) {
  if (typeof text !== 'string' || !text) return text;
  return text.replace(/"/g, '״').replace(/'/g, '׳');
}
